import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function CohortRetention() {
  const [data, setData] = useState({ cohorts: [] });
  const [loading, setLoading] = useState(true);
  const maxOffset = 12;

  useEffect(() => {
    api.get("/analytics/cohort")
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, []);

  const cellColor = (pct) => {
    if (pct == null) return "bg-slate-50 text-slate-300";
    if (pct >= 40) return "bg-emerald-600 text-white";
    if (pct >= 25) return "bg-emerald-400 text-emerald-950";
    if (pct >= 15) return "bg-emerald-200 text-emerald-900";
    if (pct >= 5) return "bg-emerald-50 text-emerald-800";
    return "bg-slate-50 text-slate-400";
  };

  return (
    <div className="space-y-6" data-testid="cohort-page">
      <header>
        <p className="text-xs tracking-[0.2em] uppercase font-semibold text-slate-500">Klantretentie</p>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-bold text-slate-900 mt-1">Cohort-analyse</h1>
        <p className="text-sm text-slate-500 mt-2 max-w-2xl">
          Elke rij is een groep klanten die voor het eerst besteld heeft in die maand. Cellen tonen het
          percentage klanten van die groep dat nog een bestelling plaatst X maanden later.
        </p>
      </header>

      <Card className="bg-white border-slate-200 p-4 sm:p-6 rounded-lg overflow-x-auto">
        {loading && <p className="text-slate-400 py-8 text-center">Laden…</p>}
        {!loading && data.cohorts.length === 0 && (
          <p className="text-slate-400 py-8 text-center">Nog geen data.</p>
        )}
        {!loading && data.cohorts.length > 0 && (
          <table className="w-full text-sm min-w-[900px]">
            <thead>
              <tr className="text-slate-600 border-b border-slate-200">
                <th className="text-left py-2 px-3 font-semibold sticky left-0 bg-white">Cohort</th>
                <th className="text-right py-2 px-3 font-semibold">Klanten</th>
                {Array.from({ length: maxOffset + 1 }, (_, i) => (
                  <th key={i} className="text-center py-2 px-2 font-semibold text-xs">M{i}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.cohorts.map((c) => (
                <tr key={c.cohort} className="border-b border-slate-100">
                  <td className="py-2 px-3 font-medium text-slate-900 sticky left-0 bg-white" data-testid={`cohort-row-${c.cohort}`}>
                    {c.cohort}
                  </td>
                  <td className="py-2 px-3 text-right text-slate-700">{c.size}</td>
                  {Array.from({ length: maxOffset + 1 }, (_, i) => {
                    const cell = c.months?.[String(i)];
                    return (
                      <td key={i} className="p-1 text-center">
                        {cell ? (
                          <div className={`rounded px-2 py-1.5 text-xs font-semibold ${cellColor(cell.pct)}`}
                               title={`${cell.count} klanten (${cell.pct}%)`}>
                            {cell.pct}%
                          </div>
                        ) : (
                          <div className="text-slate-300">—</div>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
